import { Header } from './Header';

export { shouldRenderHeader } from './Header';

export default Header;
